import React from 'react';
import { Button, Badge } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';
import { backendUrl } from '../../../../utilities/axios';
import noImage from '../../../../assets/images/no_img.jpg';

const getThumb = (video) => video.thumbnail ? `${backendUrl}/videos/${video.thumbnail}` : noImage;

const VideosTable = ({ data, page, handleUpdate, handleDelete, handleApprove }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>الصورة</th>
        <th>العنوان</th>
        <th>صانع المحتوى</th>
        <th>التصنيف</th>
        <th>المشاهدات</th>
        <th>الحالة</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((video, idx) => (
        <tr key={video._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>
            <img src={getThumb(video)} alt={video.title}
              style={{ width: 80, height: 45, objectFit: 'cover', borderRadius: 4 }} />
          </td>
          <td>{video.title}</td>
          <td>{video.creator}</td>
          <td>{video.category}</td>
          <td>{video.views}</td>
          <td>
            {video.is_active
              ? <Badge colorScheme="green">نشط</Badge>
              : <Badge colorScheme="orange">بانتظار الموافقة</Badge>}
          </td>
          <td>
            {!video.is_active && (
              <Button bg="transparent" color="teal.300" size="xs" title="موافقة" onClick={() => handleApprove(video)}>
                <FiIcons.FiCheckCircle size={20} />
              </Button>
            )}
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(video)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(video)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default VideosTable;
